module.exports = __webpack_public_path__ + "img/cards_image_AMEX.5368928.svg";